import { useTiles } from '@/srp/ResultsSection/hooks';
import { LOW_RESULTS_THRESHOLD } from '~/constants/srp';
import {
  useInventoryVehicles,
  useSimilarVehicles
} from '~/context/srp/InventoryContext';
import useGetVehiclesLoaded from './useGetVehiclesLoaded';

function useLoadedInventoryVehicles() {
  const inventoryVehicles = useInventoryVehicles();
  const { vehicles: similarVehicles, searchRequestId: svSearchRequestId } =
    useSimilarVehicles();

  const tiles = useTiles();
  const shouldHaveSimilarVehicles = tiles.length < LOW_RESULTS_THRESHOLD;

  const { loadedInventoryVehicles, loadedSimilarVehicles } =
    useGetVehiclesLoaded({
      latestInventoryVehicles: inventoryVehicles,
      latestSimilarVehicles: similarVehicles,
      shouldHaveSimilarVehicles
    });

  return {
    loadedInventoryVehicles,
    loadedSimilarVehicles,
    shouldHaveSimilarVehicles,
    svSearchRequestId
  };
}

export default useLoadedInventoryVehicles;
